import React, { forwardRef, useState } from "react";
import {
  AppBar,
  createStyles,
  Dialog,
  DialogActions,
  Divider,
  IconButton,
  makeStyles,
  Slide,
  Tab,
  Tabs,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    tabLabel: {
      fontSize: "19px",
    },
    backGround: {
      backgroundColor: theme.palette.background.default,
    },
    tabPanel: {
      overflowY: "scroll",
    },
  })
);

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

export default function TabDialog(props) {
  const { open, onClose, labels, components } = props;
  const [value, setValue] = useState(0);
  const classes = useStyles();

  const handleChangeTab = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
      classes={{ paper: classes.backGround }}
    >
      <AppBar color="inherit" position="sticky" elevation={0}>
        <DialogActions>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogActions>

        <Tabs
          value={value}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          {labels.map((label, index) => (
            <Tab
              label={label}
              classes={{ root: classes.tabLabel }}
              disableRipple
              key={index}
            />
          ))}
        </Tabs>
        <Divider />
      </AppBar>

      {components.map((Component, index) => (
        <TabPanel
          value={value}
          index={index}
          key={index}
          className={classes.tabPanel}
        >
          <Component />
        </TabPanel>
      ))}
    </Dialog>
  );
}
